import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

// Get all allowed hosts
export const getAllowedHosts = async (token) => {
  log("welcome in getAllowedHosts")

  if (!token || token === "") {
    return { error: true, message: "No token provided", hosts: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/get_allowed_hosts_api'

    const result = await axios.get(url, { headers })
    log("result.data from getAllowedHosts")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in getAllowedHosts")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching allowed hosts", hosts: [] }
  }
}

// Save (create or update) an allowed host
export const saveAllowedHost = async (token, hostData) => {
  log("welcome in saveAllowedHost")
  log(hostData)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/save_allowed_host_api'

    const result = await axios.post(url, hostData, { headers })
    log("result.data from saveAllowedHost")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in saveAllowedHost")
    log(err)
    error.value = err.message
    return { error: true, message: "Error saving host" }
  }
}

// Delete an allowed host
export const deleteAllowedHost = async (token, hostId) => {
  log("welcome in deleteAllowedHost")

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/delete_allowed_host_api'

    const result = await axios.post(url, { id: hostId }, { headers })
    log("result.data from deleteAllowedHost")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in deleteAllowedHost")
    log(err)
    error.value = err.message
    return { error: true, message: "Error deleting host" }
  }
}

// Get blocked host logs
export const getBlockedHostLogs = async (token, filters = {}) => {
  log("welcome in getBlockedHostLogs")

  if (!token || token === "") {
    return { error: true, message: "No token provided", logs: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/get_blocked_host_logs_api'

    const result = await axios.get(url, { headers, params: filters })
    log("result.data from getBlockedHostLogs")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in getBlockedHostLogs")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching blocked logs", logs: [] }
  }
}

// Clear old blocked host logs
export const clearBlockedHostLogs = async (token, days = 30) => {
  log("welcome in clearBlockedHostLogs")

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/clear_blocked_host_logs_api'

    const result = await axios.post(url, { days }, { headers })
    log("result.data from clearBlockedHostLogs")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in clearBlockedHostLogs")
    log(err)
    error.value = err.message
    return { error: true, message: "Error clearing logs" }
  }
}

const useAllowedHostsAPI = () => {
  return { error, getAllowedHosts, saveAllowedHost, deleteAllowedHost, getBlockedHostLogs, clearBlockedHostLogs }
}

export default useAllowedHostsAPI
